import { useTranslation } from 'react-i18next'

import { selectActiveBuilding } from '@/reducers/buildingSelectorReducer'
import { selectUserData } from '@/reducers/userDataReducer'
import { useAppSelector } from '@/store/hooks'

import * as S from './website-widgets.styled'
import { buildWidgetUrl } from './website-widgets.utils'

export const WebsiteWidgetsPage = () => {
  const { t } = useTranslation(['website-widgets'])
  const activeBuilding = useAppSelector(selectActiveBuilding)
  const userData = useAppSelector(selectUserData)

  const src = buildWidgetUrl(
    userData?.user?.email || '',
    activeBuilding?.id ?? userData?.buildingId?.id,
  )

  return (
    <S.Container>
      <S.Iframe allowFullScreen src={src} title={t('website-widgets:title')} />
    </S.Container>
  )
}
